import { render, staticRenderFns } from "./sendApproval.vue?vue&type=template&id=763faba3&scoped=true"
import script from "./sendApproval.vue?vue&type=script&lang=js"
export * from "./sendApproval.vue?vue&type=script&lang=js"
import style0 from "./sendApproval.vue?vue&type=style&index=0&id=763faba3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763faba3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('763faba3')) {
      api.createRecord('763faba3', component.options)
    } else {
      api.reload('763faba3', component.options)
    }
    module.hot.accept("./sendApproval.vue?vue&type=template&id=763faba3&scoped=true", function () {
      api.rerender('763faba3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/sendApproval/sendApproval.vue"
export default component.exports